import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../Appstore/store";
import { AddFlagKeyword } from "../Features/Flagkeyword";
import { IoMdArrowRoundBack } from "react-icons/io";
import { toast } from "sonner";

const validationSchema = Yup.object({
    keyword: Yup.string()
        .min(1, "Keyword must be at least 1 characters")
        .max(255, "Keyword must be at most 255 characters")
        .required("Keyword is required")
        .trim(),
});

interface FlagKeyword {
    id?: number;
    keyword: string;
}

function Addflagkeyword() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = (path: string) =>
        location.pathname === path ? "active" : "";

    const initialValues = {
        keyword: "",
    };

    const navigatetobackpage = () => {
        navigate(-1);
    };

    return (
        <>
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="card mt-4">
                                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                                    <h2 className="w-100 mb-md-0 fs-3">Add Flag Keyword</h2>
                                    <Link to={""} className="text-decoration-none ">
                                        <button
                                            onClick={navigatetobackpage}
                                            className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                        >
                                            <IoMdArrowRoundBack /> Back
                                        </button>
                                    </Link>
                                </div>
                                <div className="card-body">
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={validationSchema}
                                        onSubmit={async (values, { setSubmitting }) => {
                                            const Data: FlagKeyword = {
                                                keyword: values.keyword,
                                            };

                                            try {
                                                const response: any = await dispatch(
                                                    AddFlagKeyword(Data)
                                                );

                                                if (
                                                    response.payload &&
                                                    typeof response.payload === "object"
                                                ) {
                                                    if (response?.payload?.status === "success") {
                                                        toast.success(response?.payload?.message);
                                                        navigate("/admin/flag-keyword");
                                                    } else {
                                                        toast.error(response?.payload?.message);
                                                    }
                                                }
                                            } finally {
                                                setSubmitting(false);
                                            }
                                        }}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            isSubmitting,
                                        }) => (
                                            <div>
                                                <Form>
                                                    <div className="row">
                                                        <div className="form-group mb-3 col-md-6">
                                                            <label htmlFor="keyword">
                                                                Keyword<span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control shadow-none ${touched.keyword && errors.keyword
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                                id="keyword"
                                                                name="keyword"
                                                                placeholder="Enter Keyword"
                                                                value={values.keyword}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {touched.keyword && errors.keyword && (
                                                                <div className="text-danger">{errors.keyword}</div>
                                                            )}
                                                        </div>


                                                        <div className="d-flex">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary me-2"
                                                                disabled={isSubmitting}
                                                            >
                                                                {isSubmitting ? (
                                                                    <>
                                                                        <span
                                                                            className="spinner-border spinner-border-sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                        ></span>
                                                                        <span className="ps-2">Submitting...</span>
                                                                    </>
                                                                ) : (
                                                                    "Submit"
                                                                )}
                                                            </button>
                                                            <Link
                                                                to="/admin/flag-keyword"
                                                                className={`nav-link ${isActive("/admin/flag-keyword")}`}
                                                            >
                                                                <button className="btn btn-secondary">
                                                                    Cancel
                                                                </button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default Addflagkeyword;
